<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option v-if="firstOption" value="">{{ firstOption }}</option>
    <option
      v-for="group in selects"
      :key="group.id"
      :value="group.id"
      :selected="group.id === selected"
    >
      {{ group.description }}
    </option>
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectCustomerGroups',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : 'Nenhum',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    status: {
      type: [Number, String],
    },
  },
  watch: {
    status(newVal) {
      this.getData(newVal);
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/customer/group/all?order=description`).then(
        (res) => (this.selects = res.data)
      );
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData(this.status);
  },
};
</script>
